<div class="summary-container modal-body w-full h-full">
  <header class="header modal-header flex flex-col gap-2 place-content-between">
    <div class="flex justify-between">
      <h2 class="modal-subline py-1">Buyout rights</h2>
      <button mat-icon-button class="button-close" [mat-dialog-close]="false" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="flex items-baseline justify-between">
      <button mat-flat-button (click)="moreBuyoutRights()" [disabled]="data.allTilesUsedFlag" class="w-auto button-primary mr-4">
        <mat-icon class="material-icons-outlined mr-1">add</mat-icon>
        <ng-container i18n>Add buyout rights</ng-container>
      </button>
    </div>
  </header>
  <div class="project-content modal-main">
    <thehubz-asset-details-buyout-rights [uploadedAssetLists]="data.updatedAssetLists"></thehubz-asset-details-buyout-rights>
  </div>
  <footer class="footer-content modal-footer w-full">
    <div class="flex flex-row place-content-between items-center gap-4">
      <div class="flex items-center gap-4 ml-auto">
        <button class="save-button w-auto icon-right button-primary" mat-flat-button type="button" [mat-dialog-close]="false" (click)="closeDialog()">
          <mat-icon class="material-icons-outlined">save</mat-icon>
          <ng-container i18n>Finish</ng-container>
        </button>
      </div>
    </div>
  </footer>
</div>
